'use client';

import '../../../_virtual/_tslib.js';
import calculation from '../../helper/calculation.js';
import drawing from '../../helper/drawing.js';
import animation from '../../helper/animation.js';
import { defaultFont, LIST_COLORS, CHART_DECREASE_RATIO } from '../../helper/config.js';

/*
 * Constant
 * */
var STICK_WIDTH = 10;
var BORDER_RADIUS = 8;
var MAX_RADIUS = 30;
var GAP = 2.5;
function LollipopChart(props) {
    var _a, _b, _c;
    var config = props.config, control = props.control;
    var fontFamily = ((_b = (_a = config.default) === null || _a === void 0 ? void 0 : _a.font) === null || _b === void 0 ? void 0 : _b.family) || defaultFont.family;
    var listColors = ((_c = config.default) === null || _c === void 0 ? void 0 : _c.listColors) || LIST_COLORS;
    var decorationValue = config.chart.decorationValue;
    function candy(data, displayValue, startingPosition, valueMaxLength, color) {
        var ctx = props.ctx, chartInformation = props.chartInformation, chartNecessaryInformation = props.chartNecessaryInformation;
        var chartArea = chartNecessaryInformation.chartArea, xRange = chartNecessaryInformation.xRange;
        var chartStartingPointInYAxis = chartArea.chartStartingPointInYAxis, chartEndingPointInYAxis = chartArea.chartEndingPointInYAxis;
        var _a = calculation.getPointCoordinateInYAxis({
            chartInformation: chartInformation,
            chartStartingPointInYAxis: chartStartingPointInYAxis,
            chartEndingPointInYAxis: chartEndingPointInYAxis,
            data: data
        }, animation.easeInOutSine(control.controlRatio)), pointCoordinateInYAxis = _a.pointCoordinateInYAxis, ratio = _a.ratio;
        var maxRadius = MAX_RADIUS; // Circle radius
        var yPosition = pointCoordinateInYAxis;
        /*
         * Circle radius handler
         * */
        if (valueMaxLength / 2 + GAP > maxRadius) {
            maxRadius = valueMaxLength / 2 + GAP;
        }
        if (xRange / 3 < maxRadius) {
            maxRadius = xRange / 3;
        }
        /*
         * Text handler
         * */
        ctx.font = "700 11px ".concat(fontFamily);
        var _b = ctx.measureText(displayValue), textWidth = _b.width, actualBoundingBoxAscent = _b.actualBoundingBoxAscent, actualBoundingBoxDescent = _b.actualBoundingBoxDescent;
        var textHeight = actualBoundingBoxAscent + actualBoundingBoxDescent;
        /*
         * Calculate growth value, this will control, radius of circle base on data
         * */
        var calcTextWidth = textWidth / 2 + GAP;
        if (xRange / 4 < valueMaxLength) {
            calcTextWidth = STICK_WIDTH / 2;
        }
        var growthValue = (maxRadius - calcTextWidth) * ratio * control.controlRatio;
        if (growthValue <= 0) {
            growthValue = 0;
        }
        var radius = calcTextWidth + growthValue;
        /*
         * Calculating y-position
         * */
        if (yPosition + radius > chartStartingPointInYAxis) {
            yPosition = chartStartingPointInYAxis - radius;
        }
        if (yPosition - maxRadius < chartEndingPointInYAxis) {
            yPosition = chartEndingPointInYAxis + radius;
        }
        ctx.beginPath();
        ctx.arc(startingPosition, yPosition, radius, 0, 2 * Math.PI);
        ctx.fillStyle = color.foreground;
        ctx.fill();
        if (xRange / 4 > valueMaxLength) {
            ctx.save();
            ctx.fillStyle = '#fff';
            ctx.textAlign = 'center';
            ctx.fillText(displayValue, startingPosition, yPosition + textHeight / 2);
            ctx.restore();
        }
        ctx.closePath();
    }
    function stick(x, color) {
        var ctx = props.ctx, chartNecessaryInformation = props.chartNecessaryInformation;
        var chartArea = chartNecessaryInformation.chartArea;
        var chartStartingPointInYAxis = chartArea.chartStartingPointInYAxis, chartEndingPointInYAxis = chartArea.chartEndingPointInYAxis;
        ctx.beginPath();
        drawing.roundRect(ctx, x, chartEndingPointInYAxis, STICK_WIDTH, chartStartingPointInYAxis - chartEndingPointInYAxis, BORDER_RADIUS);
        ctx.fillStyle = color.background;
        ctx.fill();
    }
    function draw() {
        var ctx = props.ctx, chartInformation = props.chartInformation, chartNecessaryInformation = props.chartNecessaryInformation;
        var xRange = chartNecessaryInformation.xRange, chartArea = chartNecessaryInformation.chartArea;
        var chartStartingPointInXAxis = chartArea.chartStartingPointInXAxis;
        var data = chartInformation.data, xAxis = chartInformation.xAxis;
        /*
         * Find max length of value in data
         * */
        var valueMaxLength = 0;
        Object.keys(data).forEach(function (key) {
            var width = ctx.measureText(data[key]).width;
            if (valueMaxLength < width) {
                valueMaxLength = width;
            }
        });
        var startingPosition = chartStartingPointInXAxis + xRange / 2;
        xAxis.map(function (label, index) {
            var displayValue = decorationValue ? decorationValue(data[label]) : data[label].toString();
            stick(startingPosition - STICK_WIDTH / 2, LIST_COLORS[index]);
            candy(data[label], displayValue, startingPosition, valueMaxLength, listColors[index]);
            startingPosition += xRange;
        });
        control.controlRatio += CHART_DECREASE_RATIO;
        if (control.controlRatio >= 1) {
            control.controlRatio = 1;
        }
    }
    return {
        draw: draw
    };
}

export { LollipopChart as default };
//# sourceMappingURL=lollipop.js.map
